var $ = require( "jquery" );
window.jQuery = $; window.$ = $;


// Mobile hamburger toggle (smooth expand/collapse)
(function () {
  const header = document.querySelector('.site-header');
  const btn = document.querySelector('.hamburger');
  const menu = document.getElementById('mobileMenu');
  const body = document.body;

  if (!header || !btn || !menu) return;

  function setMenuTop() {
    const headerHeight = header.offsetHeight;
    menu.style.top = headerHeight + 'px';
    // The panel's height is calc(100dvh - this), so the stylesheet needs the
    // measured header height too — not just the offset.
    document.documentElement.style.setProperty('--goa-header-h', headerHeight + 'px');
  }

  // Where the page was when the menu opened, so it can be put back.
  let lockedScrollY = 0;

  function setOpen(isOpen) {
    if (isOpen) {
      setMenuTop();
    }

    const html = document.documentElement;

    header.classList.toggle('is-open', isOpen);
    btn.setAttribute('aria-expanded', String(isOpen));
    menu.setAttribute('aria-hidden', String(!isOpen));

    // Lock the page behind the panel.
    //
    // `overflow: hidden` on body is not enough: the scrolling element is
    // documentElement, so the page kept scrolling underneath, and on iOS
    // Safari overflow locking has never worked. Pinning the body with
    // position: fixed does work everywhere, at the cost of having to remember
    // and restore the scroll position — without that the page jumps to the top
    // every time the menu is dismissed.
    if (isOpen) {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      body.style.top = '-' + lockedScrollY + 'px';
      body.classList.add('menu-open');
      html.classList.add('menu-open');
      return;
    }

    // Unpinning has to happen in one go, and silently.
    //
    // Two things made closing the menu look like the page scrolling itself
    // back. Clearing `top` while the body was still `position: fixed` dropped
    // it to the top of the document for a frame; and `html` carries
    // `scroll-behavior: smooth`, so the scroll that put it back was ANIMATED —
    // you watched it travel. Unpin first, then restore with smooth scrolling
    // suppressed for that one call, so the page never moves visibly at all.
    const previousBehavior = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';

    body.classList.remove('menu-open');
    html.classList.remove('menu-open');
    body.style.top = '';
    window.scrollTo(0, lockedScrollY);

    html.style.scrollBehavior = previousBehavior;
    lockedScrollY = 0;
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    e.stopPropagation();

    setOpen(!header.classList.contains('is-open'));
  });

  menu.addEventListener('click', function (e) {
    // Tapping the scrim, or any empty part of the panel, dismisses the menu.
    // Reported from a phone: with the panel not covering the page, a tap beside
    // the list fell through and opened whatever was underneath — on the team
    // page, a leadership profile. The panel now spans the viewport, so those
    // taps land here and close instead.
    if (e.target === menu || e.target.classList.contains('mobile-nav')) {
      setOpen(false);
      return;
    }

    const link = e.target.closest('a');

    if (!link) return;

    const parentLi = link.closest('li');
    const isChildLink = parentLi && parentLi.closest('ul ul');

    if (isChildLink) {
      setOpen(false);
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 900) {
      setOpen(false);
    } else if (header.classList.contains('is-open')) {
      setMenuTop();
    }
  });

  document.addEventListener('click', function (e) {
    const chev = e.target.closest('.chev');

    if (!chev) return;

    e.preventDefault();
    e.stopPropagation();

    chev.classList.toggle('active');

    const submenu = chev.parentElement.nextElementSibling;

    if (submenu && submenu.tagName === 'UL') {
      $(submenu).slideToggle();
    }
  });
})();


// Add active class to nav items
$(document).ready(function () {
  var currentPath = window.location.pathname.replace(/\/$/, '');
  $('.primary-list li a').each(function () {
    var linkPath = $(this).attr('href');
    // Only check internal links
    if (linkPath) {
      linkPath = linkPath.replace(window.location.origin, '')
                         .replace(/\/$/, '');
      if (linkPath === currentPath) {
        $(this).closest('li').addClass('active');
      }
    }
  });
});





$('.dropdown-btn').click(function(e) {
  e.preventDefault();
  e.stopPropagation();
  
	$(this).find('ul').slideToggle();
});

// $('.menu-icon').click(function() {
// 	$(this).toggleClass('on');
// });






(function() {
    
    $('.menu-icon').click(function(e) {
      e.preventDefault();
      e.stopPropagation();

      $(this).toggleClass('on');
      $('.mobile-menu').slideToggle();
      $('body').toggleClass('overflow');
    });

    $('.mobile-menu .menu-item-has-children').append('<span class="open-menu"></span>');

    // list item click events
    $('.open-menu').on('click', function (e) {
        e.preventDefault();
        $(this).prev('ul').slideToggle(250);
        $(this).toggleClass('active');
    });

    // Accordion
    $('.accordion .trigger').on('click', function() {
		$(this).toggleClass('active');
		
			$(this).parent().next('.blurb').slideToggle('slow', function() {
				$('html, body').stop().animate({
				    'scrollTop': $(this).parent().offset().top - $(this).prev().height()
				}, 720, 'swing');			
			});
		
		$(this).parent().parent().parent().prevAll().find('.blurb').slideUp();
		$(this).parent().parent().parent().nextAll().find('.blurb').slideUp();
		$(this).parent().parent().parent().prevAll().find('.trigger').removeClass('active');
		$(this).parent().parent().parent().nextAll().find('.trigger').removeClass('active');

		$(this).parent().parent().parent().parent().parent().parent().prevAll().find('.blurb').slideUp();
		$(this).parent().parent().parent().parent().parent().parent().nextAll().find('.blurb').slideUp();
		$(this).parent().parent().parent().parent().parent().parent().prevAll().find('.trigger').removeClass('active');
		$(this).parent().parent().parent().parent().parent().parent().nextAll().find('.trigger').removeClass('active');		
		
	});
    
})();

/* Pipeline accordion toggle
   - Initially all closed
   - Click + toggles the panel
   - Accordion behavior: opens clicked item and closes others
*/
(function ($) {
  function setExpanded($item, expanded) {
    const $btn = $item.find('.pipe-toggle').first();
    const $body = $item.find('.pipe-body').first();

    $btn.attr('aria-expanded', expanded ? 'true' : 'false');

    const $icon = $item.find('.pipe-icon').first();
    if (expanded) {
      $icon.html('<span class="icon-minus"></span>');
      $item.addClass('is-open');
      const el = $body.get(0);
      $body.css('max-height', el.scrollHeight + 'px');
    } else {
      $icon.html('<span class="icon-plus"></span>');
      $item.removeClass('is-open');
      $body.css('max-height', '0px');
    }
  }

  $(function () {
    const $root = $('.pipeline');
    if (!$root.length) return;

    // initial: all closed
    $root.find('.pipe-item').each(function () {
      setExpanded($(this), false);
    });

    // toggle
    $root.on('click', '.pipe-toggle', function () {
      const $item = $(this).closest('.pipe-item');
      const isOpen = $item.hasClass('is-open');

      // close others (accordion)
      $root.find('.pipe-item').not($item).each(function () {
        setExpanded($(this), false);
      });

      // toggle current
      setExpanded($item, !isOpen);
    });

    // keep open panel height correct on resize
    $(window).on('resize', function () {
      $root.find('.pipe-item.is-open').each(function () {
        const $body = $(this).find('.pipe-body').first();
        const el = $body.get(0);
        $body.css('max-height', el.scrollHeight + 'px');
      });
    });
  });
})(jQuery);

$(window).on("scroll", function () {
  if ($(this).scrollTop() > 0) {
    $(".site-header").addClass("scroll");
  } else {
    $(".site-header").removeClass("scroll");
  }
});

// Slide toggle careers

jQuery(function($){

  $('.slide-toggle li').on('click', function() {
    $(this).toggleClass('active');
    $(this).find('.blurb').slideToggle();
  });
});




/**
* jquery.matchHeight-min.js v0.5.2
* http://brm.io/jquery-match-height/
* License: MIT
*/
(function(b){b.fn.matchHeight=function(a){if("remove"===a){var d=this;this.css("height","");b.each(b.fn.matchHeight._groups,function(b,a){a.elements=a.elements.not(d)});return this}if(1>=this.length)return this;a="undefined"!==typeof a?a:!0;b.fn.matchHeight._groups.push({elements:this,byRow:a});b.fn.matchHeight._apply(this,a);return this};b.fn.matchHeight._apply=function(a,d){var c=b(a),e=[c];d&&(c.css({display:"block","padding-top":"0","padding-bottom":"0","border-top-width":"0","border-bottom-width":"0",
height:"100px"}),e=k(c),c.css({display:"","padding-top":"","padding-bottom":"","border-top-width":"","border-bottom-width":"",height:""}));b.each(e,function(a,c){var d=b(c),e=0;d.each(function(){var a=b(this);a.css({display:"block",height:""});a.outerHeight(!1)>e&&(e=a.outerHeight(!1));a.css({display:""})});d.each(function(){var a=b(this),c=0;"border-box"!==a.css("box-sizing")&&(c+=g(a.css("border-top-width"))+g(a.css("border-bottom-width")),c+=g(a.css("padding-top"))+g(a.css("padding-bottom")));
a.css("height",e-c)})});return this};b.fn.matchHeight._applyDataApi=function(){var a={};b("[data-match-height], [data-mh]").each(function(){var d=b(this),c=d.attr("data-match-height");a[c]=c in a?a[c].add(d):d});b.each(a,function(){this.matchHeight(!0)})};b.fn.matchHeight._groups=[];b.fn.matchHeight._throttle=80;var h=-1,f=-1;b.fn.matchHeight._update=function(a){if(a&&"resize"===a.type){a=b(window).width();if(a===h)return;h=a}-1===f&&(f=setTimeout(function(){b.each(b.fn.matchHeight._groups,function(){b.fn.matchHeight._apply(this.elements,
this.byRow)});f=-1},b.fn.matchHeight._throttle))};b(b.fn.matchHeight._applyDataApi);b(window).bind("load resize orientationchange",b.fn.matchHeight._update);var k=function(a){var d=null,c=[];b(a).each(function(){var a=b(this),f=a.offset().top-g(a.css("margin-top")),h=0<c.length?c[c.length-1]:null;null===h?c.push(a):1>=Math.floor(Math.abs(d-f))?c[c.length-1]=h.add(a):c.push(a);d=f});return c},g=function(a){return parseFloat(a)||0}})(jQuery);


$('.equal').matchHeight();



// Homepage v5 — team slider prev/next
jQuery(function ($) {
  $('.h5-team-slider').each(function () {
    var $slider = $(this);
    var $track = $slider.find('.h5-team-track');
    var track = $track.get(0);
    if (!track) return;

    function step() {
      var $card = $track.find('.h5-member').first();
      var w = $card.outerWidth(true) || 400;
      return w;
    }
    // Only show the arrows when the cards actually overflow the track.
    //
    // Toggle a CLASS, not .toggle(): jQuery's show() writes an inline display
    // value, which outranks the stylesheet — so the mobile rule that hides these
    // arrows could never win, and one of them sat 19px off the side of the
    // phone. Visibility stays CSS's decision; this only reports the state.
    function updateNav() {
      $slider.find('.h5-team-nav')
        .toggleClass('is-hidden', !(track.scrollWidth > track.clientWidth + 4));
    }
    updateNav();
    $(window).on('resize', updateNav);
    $slider.find('.h5-team-nav--next').on('click', function () {
      track.scrollBy({ left: step(), behavior: 'smooth' });
    });
    $slider.find('.h5-team-nav--prev').on('click', function () {
      track.scrollBy({ left: -step(), behavior: 'smooth' });
    });
  });
});


// About v3 — leadership cards. Each card opens the person's profile in a modal.
//
// The bios are in the page and visible by default; adding `is-enhanced` is what
// hides them, so without JavaScript the copy is still readable under each card
// rather than being locked behind a button that cannot work.
//
// One <dialog> serves the grid. showModal() supplies the focus trap, Escape and
// the backdrop, so the only work here is moving the right content in and putting
// focus back where it came from on close.
(function () {
  var sections = document.querySelectorAll(".v3-leadership");
  if (!sections.length) { return; }

  Array.prototype.forEach.call(sections, function (section) {
    var grid = section.querySelector(".v3-ld-grid");
    var modal = section.querySelector(".v3-ld-modal");
    if (!grid || !modal || typeof modal.showModal !== "function") { return; }

    grid.classList.add("is-enhanced");

    var photo = modal.querySelector(".v3-ld-modal-photo");
    var name = modal.querySelector(".v3-ld-modal-name");
    var role = modal.querySelector(".v3-ld-modal-role");
    var bio = modal.querySelector(".v3-ld-modal-bio");
    var opener = null;

    // Swap the portrait without ever showing the last one under this name.
    //
    // One <img> serves the whole section, and assigning a new `src` does not
    // clear what is already painted — the browser keeps the previous image on
    // screen until the new one has decoded. Since the name, role and biography
    // are set synchronously right after, opening a second profile put the
    // PREVIOUS person's face beside the new person's name for a beat. On a
    // leadership page that is a misattribution, not a flicker.
    //
    // So the frame is blanked, the new file decoded, and only then shown. A
    // cached portrait decodes within the same frame and looks instant; an
    // uncached one shows an empty frame briefly, which is the honest state.
    function setPhoto(src) {
      if (!src) {
        photo.style.display = "none";
        photo.removeAttribute("src");
        photo.classList.remove("is-loading");
        return;
      }

      photo.style.display = "";
      photo.classList.add("is-loading");
      photo.setAttribute("src", src);

      var reveal = function () { photo.classList.remove("is-loading"); };

      if (typeof photo.decode === "function") {
        // decode() rejects if the src changes underneath it — which happens
        // when someone clicks through profiles quickly. The later call owns
        // the reveal, so a rejection here is correct and ignored.
        photo.decode().then(reveal, function () {});
      } else if (photo.complete) {
        reveal();
      } else {
        photo.addEventListener("load", reveal, { once: true });
        photo.addEventListener("error", reveal, { once: true });
      }
    }

    function open(card, face) {
      var img = card.querySelector(".v3-ld-photo img");
      var src = img ? img.getAttribute("src") : "";
      setPhoto(src);
      photo.setAttribute("alt", "");
      name.textContent = (card.querySelector(".v3-ld-name") || {}).textContent || "";
      role.textContent = (card.querySelector(".v3-ld-role") || {}).textContent || "";
      bio.innerHTML = (card.querySelector(".v3-ld-bio") || {}).innerHTML || "";
      opener = face;
      modal.showModal();
      // One dialog serves the whole section, so the biography column is the
      // same element every time and keeps whatever scroll position the last
      // profile left on it. Reset after showModal(), not before: until the
      // dialog is open it is display:none and has no scrollable box to set.
      // (scroll-behavior: smooth is on `html` only and does not inherit, so
      // this lands immediately rather than animating.)
      bio.scrollTop = 0;
    }

    grid.addEventListener("click", function (e) {
      var face = e.target.closest(".v3-ld-card-face");
      if (!face || face.tagName !== "BUTTON" || !grid.contains(face)) { return; }
      open(face.closest(".v3-ld-card"), face);
    });

    modal.querySelector(".v3-ld-close").addEventListener("click", function () {
      modal.close();
    });

    // Clicking the backdrop closes it. The dialog fills its own top layer, so a
    // click that lands on the element itself rather than its contents is outside
    // the panel.
    modal.addEventListener("click", function (e) {
      if (e.target === modal) { modal.close(); }
    });

    modal.addEventListener("close", function () {
      if (opener) { opener.focus(); opener = null; }
    });

    // "View full team" reveals the held-back part-row in place rather than
    // navigating, and retires itself once there is nothing left to reveal.
    var more = section.querySelector(".v3-ld-expand");
    if (more) {
      more.addEventListener("click", function () {
        section.classList.add("is-expanded");
        more.parentNode.style.display = "none";
      });
    }
  });
})();

// RESTORED 2026-09-08. This block was deleted by accident in 9d46365, the
// leadership-modal commit, which rewrote app.js and took 197 lines with it —
// the whole feed carousel among them. Nothing failed loudly: the CSS is built
// so that without the is-carousel class every slide stays in normal flow, so
// News simply rendered as one long grid with its pagers hidden, which is the
// designed no-JS fallback and looks deliberate. Recovered verbatim from
// 9d46365^ rather than rewritten.


// ---------------------------------------------------------------------------
// Feed carousels — "More Articles" and the Publications feed.
//
// Both used to paginate by reloading the page, and because each read the same
// `paged` query var, paging one silently paged the other wherever both appear.
// Every slide is now rendered server-side and this only moves the track.
//
// Progressive enhancement hangs on the `is-carousel` class added below: without
// it the CSS leaves every slide in normal flow, so a script failure degrades to
// a long grid rather than hiding all but the first page.
// ---------------------------------------------------------------------------
jQuery(function ($) {
  $("[data-carousel]").each(function () {
    var $root    = $(this);
    var $track   = $root.find("[data-carousel-track]").first();
    var $slides  = $track.children("[data-carousel-slide]");
    var count    = $slides.length;
    if (count < 2) { return; }

    var $viewport = $root.find(".goa-carousel-viewport").first();
    var $prev     = $root.find("[data-carousel-prev]");
    var $next     = $root.find("[data-carousel-next]");
    var $pages    = $root.find("[data-carousel-pages]");
    var $numbers  = $pages.find("[data-carousel-goto]");
    var $field    = $root.find("[data-carousel-field]");

    // How many numbers stay visible around the current page and at each end,
    // mirroring paginate_links()' mid_size / end_size.
    var mid = parseInt($root.attr("data-carousel-mid"), 10);
    var end = parseInt($root.attr("data-carousel-end"), 10);
    if (isNaN(mid)) { mid = 1; }
    if (isNaN(end)) { end = 3; }

    var index = 0;

    // On a phone the browser does this better than we do: a horizontal
    // scroll-snap row is the idiom people already know, and a pager sitting
    // beside a swipeable row is redundant. Below the breakpoint the JS hands
    // control back — the CSS turns the same markup into a native scroller —
    // and takes it again above, so a rotation from portrait to landscape does
    // not leave the page in a half-state.
    var narrow = window.matchMedia("(max-width: 767px)");

    function setMode() {
      if (narrow.matches) {
        $root.removeClass("is-carousel");
        $track.css("transform", "");
        $viewport.css("height", "");
        $slides.each(function () {
          this.inert = false;
          $(this).attr("aria-hidden", null);
        });
      } else {
        $root.addClass("is-carousel");
        go(index);
      }
    }

    // The pager numbers may sit in <li>s (articles) or be bare (publications).
    // Hiding the button alone would leave the list item behind, and the flex
    // gap still counts an empty one.
    function cell($number) {
      var $li = $number.closest("li");
      return $li.length ? $li : $number;
    }

    // Track the active slide's height so a short final page doesn't leave a gap
    // the size of a full one.
    function sizeViewport() {
      $viewport.css("height", $slides.eq(index).outerHeight());
    }

    // Collapse each run of hidden numbers into one ellipsis.
    function windowPages() {
      if (!$numbers.length) { return; }
      $pages.find(".goa-carousel-dots").remove();

      var showing = [];
      $numbers.each(function (i) {
        var visible = i < end || i >= count - end || Math.abs(i - index) <= mid;
        cell($(this)).toggle(visible);
        if (visible) { showing.push(i); }
      });

      for (var k = showing.length - 1; k > 0; k--) {
        if (showing[k] - showing[k - 1] > 1) {
          var $target = cell($numbers.eq(showing[k]));
          $target.before($target.is("li")
            ? '<li class="goa-carousel-dots" aria-hidden="true"><span class="page-numbers">&hellip;</span></li>'
            : '<span class="page-numbers goa-carousel-dots" aria-hidden="true">&hellip;</span>');
        }
      }
    }

    // Bring the section's heading back into view on a move. Without this the
    // page stays where it was while the slide under it changes height, which
    // reads as the browser wandering off towards the footer — and the reader
    // ends up looking at the bottom of a set they have not seen the top of.
    function scrollToSection() {
      var target = $root.closest("section");
      if (!target.length) { target = $root; }

      // Only offset when the header is actually fixed — it is not on desktop.
      var $header = $(".site-header");
      var offset = ($header.length && $header.css("position") === "fixed")
        ? $header.outerHeight()
        : 0;

      var top = Math.max(0, target.offset().top - offset - 24);

      // The stylesheet already sets `scroll-behavior: smooth`, so scrollTo is
      // smooth for free. Animating scrollTop with jQuery instead would have
      // each step retrigger that CSS smoothing and fight itself.
      var reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
      if ("scrollBehavior" in document.documentElement.style) {
        window.scrollTo({ top: top, behavior: reduced ? "instant" : "smooth" });
      } else {
        // Older engines ignore the options object rather than throwing, so the
        // two-argument form is the fallback, not a catch block.
        window.scrollTo(0, top);
      }
    }

    function go(n, scroll) {
      index = Math.max(0, Math.min(count - 1, n));
      $track.css("transform", "translateX(" + (-index * 100) + "%)");

      $slides.each(function (i) {
        // `inert` keeps the parked slides out of the tab order and the
        // accessibility tree; aria-hidden alone would still let focus land on
        // links sitting off-screen.
        this.inert = i !== index;
        $(this).attr("aria-hidden", i !== index ? "true" : null);
      });

      // Both class names are applied: the articles pager marks the current page
      // with .is-current, the publications pill with .current.
      $numbers.each(function (i) {
        $(this)
          .toggleClass("is-current current", i === index)
          .attr("aria-current", i === index ? "true" : null);
      });

      $prev.prop("disabled", index === 0).toggleClass("is-disabled", index === 0);
      $next.prop("disabled", index === count - 1).toggleClass("is-disabled", index === count - 1);
      if ($field.length) { $field.val(index + 1); }

      windowPages();
      sizeViewport();
      if (scroll) { scrollToSection(); }
    }

    // Every handler passes `true`; only the initial go(0) below scrolls nowhere.
    $prev.on("click", function () { go(index - 1, true); });
    $next.on("click", function () { go(index + 1, true); });
    $numbers.on("click", function () {
      go(parseInt($(this).attr("data-carousel-goto"), 10) || 0, true);
    });

    $root.find("[data-carousel-go]").on("click", function () {
      go((parseInt($field.val(), 10) || 1) - 1, true);
    });
    $field.on("keydown", function (e) {
      if (e.which === 13) { e.preventDefault(); go((parseInt($(this).val(), 10) || 1) - 1, true); }
    });

    // Card images land after first paint, so the initial measurement is short.
    $(window).on("load resize", setMode);
    setMode();
  });
});

/* ---------------------------------------------------------------------------
 * Delivery technology tiles (Our Science) — a one-at-a-time disclosure.
 *
 * The panels are open in the markup and closed here on load, so that without
 * JavaScript every route's detail is simply visible rather than unreachable.
 * ------------------------------------------------------------------------- */
(function () {
  var tiles = document.querySelectorAll(".v3-delivery-tiles");
  if (!tiles.length) { return; }

  Array.prototype.forEach.call(tiles, function (list) {
    var heads = list.querySelectorAll(".v3-tile-head[aria-expanded]");

    // Tells the stylesheet it may now hide closed panels. Until this lands,
    // every panel is visible, so a reader without JS loses nothing.
    list.classList.add("is-enhanced");

    function setOpen(head, open) {
      head.setAttribute("aria-expanded", open ? "true" : "false");
      head.parentNode.classList.toggle("is-open", open);
    }

    // Close everything the markup left open except the one the block chose.
    Array.prototype.forEach.call(heads, function (h) {
      setOpen(h, h.getAttribute("aria-expanded") === "true");
    });

    list.addEventListener("click", function (e) {
      var head = e.target.closest(".v3-tile-head[aria-expanded]");
      if (!head || !list.contains(head)) { return; }
      var open = head.getAttribute("aria-expanded") === "true";
      Array.prototype.forEach.call(heads, function (h) { setOpen(h, false); });
      setOpen(head, !open);
    });
  });
})();

// Contact form -> HubSpot.
//
// The form works without any of this: it is a real POST to admin-post.php,
// which validates, forwards to HubSpot and redirects back with a message. This
// only removes the page reload and puts the errors next to the fields that
// caused them.
//
// Nothing here is a security boundary. The server re-checks everything,
// including the honeypot, so a bot that ignores this code gains nothing.
(function () {
  var forms = document.querySelectorAll("form.v3-form[data-goa-contact]");
  if (!forms.length || !window.fetch) { return; }

  Array.prototype.forEach.call(forms, wire);

  // There are two of these now — the contact page's, and the investor-interest
  // pop-up's, which is on every page. Same endpoint, same error shapes, same
  // markup for a field error; the only thing that differs is where a success
  // goes, and that is decided once, below.
  function wire(form) {
  var wrap = form.closest(".v3-contact-form") || form.closest(".iv-form-wrap") || form.parentNode;

  function clearErrors() {
    Array.prototype.forEach.call(form.querySelectorAll(".v3-field.is-error"), function (f) {
      f.classList.remove("is-error");
    });
    Array.prototype.forEach.call(form.querySelectorAll(".v3-field-error"), function (e) {
      e.parentNode.removeChild(e);
    });
  }

  function showFieldError(name, text) {
    var input = form.querySelector('[name="' + name + '"]');
    if (!input) { return; }
    var field = input.closest(".v3-field");
    if (!field || field.querySelector(".v3-field-error")) { return; }
    field.classList.add("is-error");
    var note = document.createElement("span");
    note.className = "v3-field-error";
    note.textContent = text;
    field.appendChild(note);
  }

  function message(type, text) {
    var existing = wrap.querySelector(".v3-form-message");
    if (existing) { existing.parentNode.removeChild(existing); }
    var el = document.createElement("div");
    el.className = "v3-form-message v3-form-message--" + type;
    el.setAttribute("role", type === "error" ? "alert" : "status");
    el.textContent = text;
    wrap.insertBefore(el, wrap.firstChild);
    return el;
  }

  var REASONS = {
    invalid: "Please check the highlighted fields and try again.",
    expired: "That form had been open a while and expired. Please try sending it again.",
    unconfigured: "The contact form is not accepting messages yet. Please email contact@goathera.com in the meantime.",
  };

  form.addEventListener("submit", function (e) {
    // Let the browser's own required/email checks run first — if they fail it
    // shows its messages and never reaches here.
    if (form.checkValidity && !form.checkValidity()) { return; }

    e.preventDefault();
    clearErrors();

    var button = form.querySelector(".v3-form-submit");
    var label = button ? button.textContent : "";
    if (button) {
      button.disabled = true;
      button.classList.add("is-sending");
      button.textContent = "Sending\u2026";
    }

    var data = new FormData(form);
    data.append("goa_ajax", "1");

    // NOT form.action.
    //
    // A form exposes its own named controls as properties of itself, and this
    // form carries a hidden <input name="action"> for admin-post. That input
    // therefore SHADOWS the form's action URL: `form.action` hands back the
    // element, which stringifies to "[object HTMLInputElement]", and the
    // submission went to /contact/[object%20HTMLInputElement]. The attribute is
    // the only reliable way to read it while a control of that name exists.
    var endpoint = form.getAttribute("action");

    // Recorded as the response arrives so both failure paths can report it.
    // Stays 0 when the request never got an answer at all.
    var httpStatus = 0;

    function restore() {
      if (!button) { return; }
      button.disabled = false;
      button.classList.remove("is-sending");
      button.textContent = label;
    }

    fetch(endpoint, {
      method: "POST",
      body: data,
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (r) { httpStatus = r.status; return r.json(); })
      .then(function (res) {
        if (res && res.ok) {
          // The pop-up confirms in place. Navigating would throw away the page
          // somebody was reading in order to tell them a form worked, and the
          // whole point of the pop-up is that it does not take them off the
          // page. The wording is the server's own, so both paths say the same
          // thing.
          // The signup confirms where it stands — the footer strip is at the
          // bottom of whatever somebody was reading, and sending them to a
          // reloaded page to say thank you throws that away.
          if (form.hasAttribute("data-goa-inline") && !form.closest(".iv-dialog")) {
            wrap.innerHTML = "";
            message("success", form.getAttribute("data-thanks") ||
              "Thank you — you are signed up.");
            markSignedUp(form);
            // Confirms in place, so nothing navigates and no callback is needed.
            goaTrack("form_submission", goaFormInfo(form));
            return;
          }

          var dialog = form.closest(".iv-dialog");
          if (dialog) {
            var panel = form.closest(".iv-panel");
            if (panel) { panel.classList.add("is-sent"); }
            wrap.innerHTML = "";
            // Each panel carries its own wording, so the deck request is not
            // thanked in the investor pop-up's words. Same string the server
            // renders on the no-JavaScript path, so both say the same thing.
            message("success", dialog.getAttribute("data-thanks") ||
              "Thank you — we will be in touch.");
            markSignedUp(form);
            goaTrack("form_submission", goaFormInfo(form));
            return;
          }

          // Everywhere else: go to the URL the server just handed back — the
          // same one the no-JavaScript path redirects to.
          //
          // This used to build its own confirmation, and drifted from the
          // block's: the server's success state carries a "Send another
          // message" link and this did not, so with JS on you reached a dead
          // end. The URL never changed either, so a reload dropped you back to
          // a blank form. Letting the server own the success state means there
          // is only one of it.
          //
          // This one navigates, so the push has to be given a chance to fire
          // before the page goes. goaTrack's callback does that, and its own
          // timeout guarantees the redirect still happens when GTM is blocked
          // by consent — a refused cookie must not cost us the enquiry.
          var target = res.redirect ||
            (window.location.pathname + "?contact=sent#contact-form");
          goaTrack("form_submission", goaFormInfo(form), function () {
            window.location.href = target;
          });
          return;
        }
        restore();
        var errors = (res && res.errors) || {};
        // `reason` is the server's own word for what went wrong — invalid,
        // expired, unconfigured, failed — which is more use in a report than a
        // status code would be, since the request itself returned 200.
        goaTrack("form_error", {
          form_name: goaFormInfo(form).form_name,
          form_location: goaFormInfo(form).form_location,
          error_reason: (res && res.reason) || "unknown",
          error_fields: Object.keys(errors).join(",") || undefined,
          status: httpStatus,
        });
        Object.keys(errors).forEach(function (name) { showFieldError(name, errors[name]); });
        message("error", REASONS[res && res.reason] ||
          "Sorry \u2014 something went wrong sending your message. Please try again, or email contact@goathera.com.");
        var first = form.querySelector(".v3-field.is-error input, .v3-field.is-error select, .v3-field.is-error textarea");
        if (first) { first.focus(); }
      })
      .catch(function () {
        // Network failure. Do not pretend it worked — say so, and leave what
        // they typed exactly where it is.
        restore();
        goaTrack("form_error", {
          form_name: goaFormInfo(form).form_name,
          form_location: goaFormInfo(form).form_location,
          error_reason: "network",
          status: httpStatus,
        });
        message("error", "Sorry \u2014 we could not reach the server. Please check your connection and try again, or email contact@goathera.com.");
      });
  });
  }
})();

/* ---------------------------------------------------------------------------
 * GA4 / GTM — one push helper for the whole site
 *
 * GTM is injected by Complianz with consent gating, so on a page where nobody
 * has consented GTM never loads. dataLayer is still just an array: the push
 * succeeds, sits there, and is processed if GTM loads later. Nothing here
 * depends on GTM being present, and nothing here may BREAK if it is absent —
 * which is the whole reason for the callback handling below.
 *
 * `after` is for the one case that navigates: the contact and careers forms
 * redirect on success, and a push followed immediately by a redirect is a race
 * the tag usually loses. GTM calls eventCallback once its tags have fired, so
 * the navigation hangs off that — with our OWN timeout as the backstop,
 * because if GTM is blocked by consent the callback never comes and the
 * visitor would be stranded on a form that appears to have done nothing.
 *
 * Failing open, always: no analytics is an inconvenience, a form that does not
 * submit is a lost enquiry.
 * ------------------------------------------------------------------------ */
function goaTrack(event, params, after) {
  var payload = { event: event };
  if (params) {
    for (var k in params) {
      if (Object.prototype.hasOwnProperty.call(params, k) &&
          params[k] !== undefined && params[k] !== null && params[k] !== '') {
        payload[k] = params[k];
      }
    }
  }

  var done = false;
  function go() {
    if (done) { return; }
    done = true;
    if (after) { after(); }
  }

  if (after) {
    payload.eventCallback = go;
    payload.eventTimeout = 1000;
    // GTM absent, blocked, or slow. 1.2s is past eventTimeout, so this only
    // ever fires when GTM did not.
    setTimeout(go, 1200);
  }

  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (e) {
    go();
  }

  if (!after) { return; }
}

/** What analytics calls a given form, and where it sits. */
function goaFormInfo(form) {
  return {
    form_name: form.getAttribute("data-goa-form") || "unknown",
    form_location: form.getAttribute("data-goa-location") || "page",
  };
}

/* ---------------------------------------------------------------------------
 * The "leave your details" pop-ups
 *
 * Two of them: the investor-interest panel, opened by every Invest button while
 * the offering is not live, and the deck-request panel, opened by the homepage
 * hero while the deck is not ready. Each is rendered only when its own switch
 * is on, so there may be none, one or both on a page.
 *
 * Every trigger is an ordinary link to the panel's id, which works on its own
 * with no scripting at all; this upgrades those links to real modals.
 *
 * <dialog>.showModal() is doing the hard parts: focus is trapped, Escape
 * closes, the rest of the page goes inert, and the panel sits in the top layer
 * above anything with a z-index. None of that is worth reimplementing.
 * ------------------------------------------------------------------------ */
(function () {
  var dialogs = document.querySelectorAll("dialog.iv-dialog");
  if (!dialogs.length) { return; }

  var opener = null;

  function open(dialog, trigger) {
    if (!dialog || typeof dialog.showModal !== "function" || dialog.open) { return; }
    opener = trigger || null;
    dialog.showModal();
    // The heading, not the first field: it names what the panel is for, and
    // landing in a text input skips that for anyone using a screen reader.
    var title = dialog.querySelector(".iv-title");
    if (title) {
      title.setAttribute("tabindex", "-1");
      title.focus({ preventScroll: true });
    }
  }

  // Any trigger anywhere — header, mobile menu, footer, the homepage hero, and
  // the per-page CTA link fields, which are content and so cannot carry a data
  // attribute. The href is what they all have in common.
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a[href*='#']");
    if (!link) { return; }
    var hash = (link.getAttribute("href") || "").split("#")[1];
    if (!hash) { return; }
    var dialog = document.getElementById(hash);
    if (!dialog || !dialog.classList.contains("iv-dialog")) { return; }

    e.preventDefault();
    // The mobile menu is a fixed panel over the page; leaving it open behind a
    // modal traps the visitor behind two layers when the modal closes.
    if (document.querySelector(".site-header.is-open")) {
      document.querySelector(".hamburger").click();
    }
    open(dialog, link);
  });

  Array.prototype.forEach.call(dialogs, function (dialog) {
    dialog.querySelector(".iv-close").addEventListener("click", function () {
      dialog.close();
    });

    // Clicking the backdrop. The dialog fills its own top layer, so a click
    // that lands on the element itself rather than on the panel inside it is
    // outside.
    dialog.addEventListener("click", function (e) {
      if (e.target === dialog) { dialog.close(); }
    });

    // Put focus back where it came from, or the next Tab starts at the top of
    // the document — which on a long page is a long way from the button just
    // pressed.
    dialog.addEventListener("close", function () {
      if (opener && document.contains(opener)) { opener.focus(); }
      opener = null;
    });
  });

  // Arriving on /?contact=sent#invest-interest — the no-JavaScript path's
  // return trip, or a shared link. The panel holds the confirmation already;
  // this just makes it a modal rather than a block at the foot of the page.
  if (window.location.hash) {
    var landed = document.getElementById(window.location.hash.slice(1));
    if (landed && landed.classList.contains("iv-dialog")) { open(landed, null); }
  }
})();

/**
 * Remember that this browser has signed up, so the pop-up never asks again.
 *
 * Deliberately not tied to the pop-up: somebody who signs up in the footer has
 * answered the question, and being asked again by a modal afterwards is the
 * single most irritating thing this feature could do.
 *
 * Wrapped because storage throws outright in Safari's private mode rather than
 * failing quietly, and a dead analytics-grade nicety must never take the form's
 * success handler down with it.
 */
function markSignedUp(form) {
  try {
    if (form && form.querySelector('[name="goa_form_kind"]') &&
        form.querySelector('[name="goa_form_kind"]').value === "signup") {
      window.localStorage.setItem("goaSignup", JSON.stringify({ subscribed: true }));
    }
  } catch (e) {}
}

/* ---------------------------------------------------------------------------
 * The first-visit signup pop-up
 *
 * Andy's rules, 18 Sep 2026, and the restraint in them is the feature:
 *
 *   - Never immediately. After a delay OR a scroll depth, whichever comes
 *     first, so somebody who is reading is asked and somebody who just landed
 *     is not.
 *   - One exposure. Shown once per visit, not once per page.
 *   - A dismissal is an answer, for thirty days. Not for ever — someone who is
 *     not ready today may well be in a month.
 *   - Once they sign up, never again on this device, wherever they signed up.
 *
 * All four thresholds come from data attributes so they can be tuned in
 * wp-admin without a build. See includes/signup.php.
 * ------------------------------------------------------------------------ */
(function () {
  var dialog = document.getElementById("signup");
  if (!dialog || typeof dialog.showModal !== "function") { return; }

  var DELAY   = (parseInt(dialog.getAttribute("data-auto-delay"), 10) || 10) * 1000;
  var DEPTH   = (parseInt(dialog.getAttribute("data-auto-scroll"), 10) || 35) / 100;
  var DAYS    = parseInt(dialog.getAttribute("data-suppress-days"), 10) || 30;

  // Storage can throw rather than return null — Safari private mode, and any
  // browser set to block site data. A pop-up that cannot remember is better
  // than a page that cannot load, so every read and write is guarded and the
  // failure mode is "do not show it".
  function read(store, key) {
    try { return window[store].getItem(key); } catch (e) { return null; }
  }
  function write(store, key, value) {
    try { window[store].setItem(key, value); } catch (e) {}
  }

  function suppressed() {
    var raw = read("localStorage", "goaSignup");
    if (!raw) { return false; }
    var state;
    try { state = JSON.parse(raw); } catch (e) { return false; }
    if (!state) { return false; }
    if (state.subscribed) { return true; }
    if (!state.dismissedAt) { return false; }
    return (Date.now() - state.dismissedAt) < DAYS * 86400000;
  }

  // One exposure per visit, across pages — sessionStorage is exactly the
  // lifetime being described.
  if (suppressed() || read("sessionStorage", "goaSignupShown")) { return; }

  var done = false;

  function show() {
    if (done || dialog.open) { return; }
    if (permanentSignupVisible()) { standDown(); return; }
    // Never over another modal, and never while the mobile menu is open: an
    // uninvited panel on top of something the visitor deliberately opened is
    // the version of this that people complain about.
    if (document.querySelector("dialog[open]") ||
        document.querySelector(".site-header.is-open")) { return; }
    done = true;
    window.removeEventListener("scroll", onScroll);
    clearTimeout(timer);
    write("sessionStorage", "goaSignupShown", "1");
    dialog.showModal();
    var title = dialog.querySelector(".iv-title");
    if (title) {
      title.setAttribute("tabindex", "-1");
      title.focus({ preventScroll: true });
    }
  }

  /*
   * Is a permanent signup already on screen?
   *
   * Somebody who has scrolled to the footer strip is looking at the thing the
   * pop-up exists to offer. Covering it with a modal asking the same question
   * is the single most irritating version of this feature, and it is what
   * happened: at 35% the timer had not fired, but reaching the footer put the
   * scroll trigger past its threshold and the panel landed on top of the form
   * being filled in.
   *
   * So the pop-up stands down for the rest of the visit the moment one is
   * visible. It has not been dismissed — nothing is written to storage — it
   * has simply been made redundant by a better offer.
   */
  function permanentSignupVisible() {
    var forms = document.querySelectorAll(".su-form");
    for (var i = 0; i < forms.length; i++) {
      if (forms[i].closest(".iv-dialog")) { continue; }
      var box = forms[i].getBoundingClientRect();
      if (box.bottom > 0 && box.top < window.innerHeight) { return true; }
    }
    return false;
  }

  function standDown() {
    done = true;
    clearTimeout(timer);
    window.removeEventListener("scroll", onScroll);
  }

  function onScroll() {
    if (permanentSignupVisible()) { standDown(); return; }
    var scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable > 0 && window.scrollY / scrollable >= DEPTH) { show(); }
  }

  var timer = setTimeout(show, DELAY);
  window.addEventListener("scroll", onScroll, { passive: true });

  // Closing without signing up is an answer. The close event covers the X, the
  // backdrop and Escape alike — all three are handled by the shared dialog
  // wiring above, and all three mean the same thing.
  dialog.addEventListener("close", function () {
    var raw = read("localStorage", "goaSignup");
    var state = {};
    try { state = raw ? (JSON.parse(raw) || {}) : {}; } catch (e) { state = {}; }
    if (state.subscribed) { return; }
    state.dismissedAt = Date.now();
    write("localStorage", "goaSignup", JSON.stringify(state));
  });
})();

/* ---------------------------------------------------------------------------
 * The Invest button
 *
 * Every Invest link on the site carries `data-goa-invest`, whose value says
 * what it currently does: "popup" while the interest pop-up stands in for the
 * offering, "interim-page" for our own /invest/, "portal" once DealMaker is
 * live. PHP decides that, because only PHP knows what the configured portal is.
 *
 * WHY THIS MATTERS MORE LATER THAN IT DOES NOW. Today the button opens a form
 * and the submission is the conversion, which analytics already sees. When
 * DealMaker goes live the button leaves for a site that is not ours: there is
 * no submission on our side, no thank-you page, nothing. The click is the only
 * evidence that the site did its job, and if it is not recorded the funnel
 * simply ends at "visited a page".
 *
 * Delegated from the document so it covers the header, the mobile menu, the
 * footer, the per-page CTA bands and anything added later, with no second
 * place to remember.
 * ------------------------------------------------------------------------ */
(function () {
  document.addEventListener("click", function (e) {
    var link = e.target.closest("a[data-goa-invest]");
    if (!link) { return; }

    var kind = link.getAttribute("data-goa-invest") || "unknown";

    /*
     * The pop-up case is NOT a navigation — the modal handler intercepts the
     * click and nothing unloads — so it needs no callback and must not be
     * delayed. Recorded under its own name too: "opened the interest form" and
     * "left for the portal" are different events and reporting them as one
     * would make the switchover look like a cliff.
     */
    if (kind === "popup") {
      goaTrack("invest_click", { invest_destination: kind, link_text: (link.textContent || "").trim() });
      return;
    }

    var href = link.getAttribute("href") || "";
    var newTab = link.target === "_blank" || e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1;

    // A link that opens a new tab does not unload this page, so the push has
    // all the time it needs. Only a same-tab navigation has to be held.
    if (newTab) {
      goaTrack("invest_click", { invest_destination: kind, link_url: href, link_text: (link.textContent || "").trim() });
      return;
    }

    e.preventDefault();
    goaTrack("invest_click",
      { invest_destination: kind, link_url: href, link_text: (link.textContent || "").trim() },
      function () { window.location.href = href; });
  });
})();

/*
 * Hero loop clip.
 *
 * The <video> ships with no sources and preload="none", so nothing is fetched
 * until this decides the visitor should have it. That ordering is the point:
 * the still underneath is already a complete hero, and the clip is 1.7 MB of
 * decoration on top of it. Anyone who has asked for less motion, or whose
 * phone has asked us to use less data, simply keeps the still and pays
 * nothing.
 */
(function () {
  var video = document.querySelector(".h5-hero-video");

  if (!video) {
    return;
  }

  var motion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  var net = navigator.connection || {};
  var slow = /(^|-)2g$/.test(net.effectiveType || "");

  // The still is the fallback in every one of these cases, and it is already
  // on screen — so there is nothing to do but leave it alone.
  if ((motion && motion.matches) || net.saveData || slow) {
    return;
  }

  /*
   * Where the clip really begins. The supplied one opens on half a second of
   * black: a graceful start for something you press play on, a blink for
   * something that loops forever. It is skipped on the first play and on
   * every loop, which is also why the element carries no `loop` attribute —
   * looping back to 0 is the thing being avoided.
   */
  var start = parseFloat(video.getAttribute("data-start")) || 0;

  var play = function () {
    // Autoplay can still be refused (a browser-level setting, a background
    // tab). A rejected promise is not an error worth reporting — it just
    // means the visitor keeps the still.
    var p = video.play();

    if (p && p.catch) {
      p.catch(function () {});
    }
  };

  ["webm", "mp4"].forEach(function (ext) {
    var src = video.getAttribute("data-src-" + ext);

    if (src) {
      var source = document.createElement("source");
      source.src = src;
      source.type = "video/" + ext;
      video.appendChild(source);
    }
  });

  /*
   * Fade in on the first frame that is actually painted, not on `play` — and
   * `play` fires while the element is still showing nothing, so fading there
   * would dip the photo underneath towards black before the picture arrived.
   */
  video.addEventListener("timeupdate", function onPaint() {
    if (video.currentTime >= start) {
      video.classList.add("is-playing");
      video.removeEventListener("timeupdate", onPaint);
    }
  });

  // Seek first, play second. Playing before the seek lands would show the
  // black lead-in — the one frame this whole arrangement exists to skip.
  video.addEventListener("loadedmetadata", function () {
    if (start) {
      video.currentTime = start;
    }

    play();
  });

  video.addEventListener("ended", function () {
    video.currentTime = start;
    play();
  });

  video.preload = "auto";
  video.load();

  /*
   * Off-screen it is a decoded 1080p frame loop costing battery for nobody's
   * benefit. Most browsers throttle a hidden tab, not a video merely scrolled
   * past, so this does it explicitly.
   */
  if (window.IntersectionObserver) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          play();
        } else {
          video.pause();
        }
      });
    }, { threshold: 0 }).observe(video);
  }
})();
